import { render, staticRenderFns } from "./donor-box.vue?vue&type=template&id=5622568f&scoped=true"
import script from "./donor-box.vue?vue&type=script&lang=ts"
export * from "./donor-box.vue?vue&type=script&lang=ts"
import style0 from "./donor-box.vue?vue&type=style&index=0&id=5622568f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622568f",
  null
  
)

export default component.exports